import { render, staticRenderFns } from "./navbar-events-menu.vue?vue&type=template&id=4d57d155&scoped=true&"
import script from "./navbar-events-menu.vue?vue&type=script&lang=ts&"
export * from "./navbar-events-menu.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-events-menu.vue?vue&type=style&index=0&id=4d57d155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57d155",
  null
  
)

export default component.exports